// Helpers centralizados de data/hora (padrão Brasil, America/Sao_Paulo).
// Comportamento idêntico ao anterior — apenas centralizado neste arquivo.

const TZ = "America/Sao_Paulo";

// Data/hora a partir de ISO/UTC -> "16/07/2026, 19:30" no fuso de Brasília.
export function brDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("pt-BR", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

// Igual a brDateTime, porém com fallback vazio (usado em listas onde "" é aceitável).
export function fmtDateTime(s) {
  if (!s) return "";
  const d = new Date(s);
  if (isNaN(d)) return String(s);
  return d.toLocaleString("pt-BR", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

// DATA PURA (YYYY-MM-DD) -> DD/MM/YYYY por split seguro (sem new Date, evita deslocamento de fuso).
export function fmtDateBR(dateString) {
  if (!dateString) return "—";
  const s = String(dateString);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("pt-BR", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" });
}

// Faixa de aula amigável: "16/07/2026 · 20:00–21:30" (data pura + horários como informados).
export function fmtLessonRange(date, startTime, endTime) {
  const d = fmtDateBR(date);
  const t = [startTime, endTime].filter(Boolean).join("–");
  return t ? `${d} · ${t}` : d;
}
